jQuery(document).ready( function($) {
  $('#location-menu-bttn').on('click', function(){
    var a = $(this).attr('data-dabpen');
    $('html, body').animate({scrollTop: $(a).offset().top - 150}, 'slow');
  });
})
